module.exports = __webpack_public_path__ + "static/media/photo64.c306a8ec.jpg";